import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AvatarApi } from 'services/avatar';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { SmallCard } from 'styled_components/Common/SmallCard';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

class CardScroller extends Component {
	constructor(props) {
		super(props);
		this.avatarApi = new AvatarApi();
		this.state = {
			selected: null,
			buttonActive: false,
			showUpperFilter: false,
		};
	}

	renderCards = data => {
		const { onClick, selectedId, type } = this.props;
		if (!data || data.length === 0) {
			return <div></div>;
		}
		if (type !== 'share') {
			return data.map((user, index) => {
				const profileImage = user?.profileImage
					? this.avatarApi.get(user?.profileImage)
					: this.avatarApi.getGenericAvatar();
				const username = `${user?.firstName}`;

				return (
					<ActionButton
						key={`user-card-${user?.userId}-${index + 1}`}
						index={index + 1}
						user={user}
						onClick={() => onClick(user?.userId)}
						selected={selectedId}
						className={user?.userId === parseInt(selectedId) ? 'xs selected' : 'xs'}
						cypressId={`card-${index}`}
					>
						<div className='user-card'>
							<div className='image-container'>
								<img src={profileImage} />
							</div>
							<div className='overlay'>
								<div className='users-name body10'>{username}</div>
							</div>
						</div>
					</ActionButton>
				);
			});
		} else {
			return data.map((item, index) => {
				return (
					<SmallCard
						key={`user-card-${item?.id}`}
						className={item?.id === selectedId ? 'xs selected' : 'xs'}
						cypressId={`card-${index}`}
						onClick={() => onClick(item?.id)}
						data={item}
						index={index}
					/>
				);
			});
		}
	};

	onScrollStop = scrollTop => {
		const { showUpperFilter } = this.state;

		if (scrollTop === 0 && showUpperFilter) {
			this.setState({ showUpperFilter: false });
		} else if (scrollTop !== 0 && !showUpperFilter && scrollTop) {
			this.setState({ showUpperFilter: true });
		}
	};

	render() {
		//const { showUpperFilter } = this.state;
		const { data } = this.props;
		const shouldScroll = data && data.length >= 5 ? true : false;

		return (
			<div className={shouldScroll ? 'card-scroller scroll' : 'card-scroller'}>
				{shouldScroll && (
					<>
						{/* {showUpperFilter && <div className='upper-filter'></div>}
						<div className='lower-filter'></div> */}
						<ScrollView onScrollStop={this.onScrollStop}>
							{data && this.renderCards(data)}
						</ScrollView>
					</>
				)}
				{!shouldScroll && (
					<ScrollView onScrollStop={this.onScrollStop}>{data && this.renderCards(data)}</ScrollView>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
	};
}

export default connect(mapStateToProps)(CardScroller);
